import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import Checkbox from "@material-ui/core/Checkbox";
import { FormControlLabel } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

export default class EditInfoFieldDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          <div style={{ display: "flex" }}>
            {this.props.infoField
              ? languages.teamInfo.editInfoField
              : languages.teamInfo.addInfoField}
            <div style={{ flex: "1 1 10%" }} />
            {(this.props.tournament.lang || []).length > 1 &&
              this.props.playersPage && (
                <FormControl style={{ paddingRight: 9 }}>
                  {/* <InputLabel htmlFor="reqOrOpt">
                  {languages.general.language}
                </InputLabel> */}
                  <Select
                    value={this.props.lang || "0"}
                    onChange={this.props.handleChange}
                    inputProps={{
                      name: "lang",
                      id: "lang",
                    }}
                  >
                    <MenuItem value={"0"}>
                      {(this.props.tournament.lang || [])[0].toUpperCase()}
                    </MenuItem>
                    {(this.props.tournament.lang || []).slice(1).map((lang) => {
                      return (
                        <MenuItem key={lang} value={lang}>
                          {lang.toUpperCase()}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              )}
          </div>
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText />
            <TextField
              autoFocus
              margin="dense"
              label={languages.general.name}
              value={this.props.name}
              name="name"
              onChange={
                this.props.lang !== "0"
                  ? this.props.handleTrsNameChange
                  : this.props.handleChange
              }
              type="text"
              fullWidth
            />

            {!this.props.refereesPage && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.props.showOnLive}
                    onChange={this.props.handleShowOnLiveCheck}
                    color="primary"
                    name="showOnLive"
                  />
                }
                label={languages.formatString(
                  languages.teamInfo.showOnLive,
                  this.props.tournament.individualPlayers
                    ? languages.livePages.myTeam2
                    : languages.livePages.myTeam
                )}
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.props.handleSubmit}
              disabled={this.props.submitDisabled}
              variant="contained"
              color="primary"
              type="submit"
            >
              {this.props.infoField
                ? languages.general.save
                : languages.general.add}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
